module.exports = __webpack_public_path__ + "static/media/task1Planet4.93525a7f.png";